module.exports = __webpack_public_path__ + "static/golfplus-76c4cdd31446eebe8df8ab1e471a1564.png";